import styles from "./peripheral-used.module.css";

import { ReactComponent as Check } from "../../svg/check.svg";
import { ReactComponent as Dash } from "../../svg/dash.svg";

export interface PeripheralUsedProps {
  isUsed: boolean;
}

export function PeripheralUsed(props: PeripheralUsedProps) {
  if (props.isUsed) {
    return (
      <div className={styles["is-used-icon"]}>
        <Check />
      </div>
    );
  }

  return (
    <div className={styles["is-used-icon"]}>
      <Dash />
    </div>
  );
}
